/* One category choice. Liquid owns the static diagrams and measuring notes. */
(() => {
  if (window.LaleyMeasurementHub?.init) {
    window.LaleyMeasurementHub.init(document);
    return;
  }

  const initialized = new WeakMap();
  const instances = new Set();
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const hashProfile = (hash) => {
    if (!hash.startsWith('#hub-')) return '';
    try { return decodeURIComponent(hash.slice(5)); } catch (_error) { return ''; }
  };

  function initialize(root) {
    if (initialized.has(root)) return initialized.get(root);
    const select = root.querySelector('[data-hub-category]');
    const panels = Array.from(root.querySelectorAll('[data-hub-panel]'));
    if (!select || !panels.length) return null;

    const options = Array.from(select.options || []);
    const profiles = panels.map((panel) => {
      const profile = panel.dataset.hubPanel;
      const option = options.find((item) => item.value === profile);
      return option ? { profile, panel, option } : null;
    }).filter(Boolean);
    if (!profiles.length) return null;

    const findProfile = (key) => profiles.find((entry) => entry.profile === key);
    const preferred = findProfile(root.dataset.defaultProfile) || profiles[0];
    const writeRoute = (profile) => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('kategori', profile);
        url.searchParams.delete('mal');
        if (url.hash.startsWith('#hub-')) url.hash = `hub-${encodeURIComponent(profile)}`;
        else if (profiles.some((entry) => `#${entry.panel.id}` === url.hash)) url.hash = findProfile(profile).panel.id;
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (_error) {
        // The category remains usable in restrictive previews without History access.
      }
    };

    const paint = (entry, updateURL = false) => {
      select.value = entry.profile;
      panels.forEach((panel) => { panel.hidden = panel !== entry.panel; });
      root.querySelectorAll('[data-hub-body-reference][data-adult-body-only]').forEach((reference) => {
        reference.hidden = entry.profile === 'kids';
        if (reference.hidden) reference.open = false;
      });
      const announcement = root.querySelector('[data-hub-announcement]');
      if (announcement) {
        const prefix = clean(root.dataset.announcementProfile);
        announcement.textContent = `${prefix ? `${prefix} ` : ''}${clean(entry.option.textContent)}.`;
      }
      if (updateURL) writeRoute(entry.profile);
    };

    const readRoute = () => {
      let profile = preferred;
      try {
        const url = new URL(window.location.href);
        let panelHash = '';
        try { panelHash = decodeURIComponent(url.hash.slice(1)); } catch (_error) { /* Ignore malformed hashes. */ }
        profile = findProfile(url.searchParams.get('kategori')) || findProfile(hashProfile(url.hash))
          || profiles.find((entry) => entry.panel.id === panelHash) || preferred;
      } catch (_error) { /* Default server order remains the safe fallback. */ }
      paint(profile);
    };

    root.addEventListener('change', (event) => {
      if (event.target !== select) return;
      const entry = findProfile(select.value);
      if (entry) paint(entry, true);
    });
    root.classList.add('is-enhanced');
    const state = { root, readRoute };
    initialized.set(root, state);
    instances.add(state);
    readRoute();
    return state;
  }

  function init(scope = document) {
    const roots = Array.from(scope.querySelectorAll('[data-measure-hub]'));
    if (scope.matches?.('[data-measure-hub]')) roots.unshift(scope);
    roots.forEach(initialize);
  }

  const syncRoute = () => {
    instances.forEach((instance) => {
      if (!instance.root.isConnected) { instances.delete(instance); return; }
      instance.readRoute();
    });
  };
  window.LaleyMeasurementHub = { init };
  window.addEventListener('popstate', syncRoute);
  window.addEventListener('hashchange', syncRoute);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
